import React, {ReactNode} from "react";
import styles from "./MainButton.module.scss";

type ButtonProps = {
  text: string;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  icon?:ReactNode
  
};

const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  className = "",
  type ,
  disabled = false,

   icon
}) => {
  return (
    <button
      className={`${styles.main_button} ${className}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {
        icon ? icon :null
      }
      <span>{text}</span>
    </button>
  );
};

export default Button;
